/*
 * Wellife 1+1 akcios kosarbanner.
 *
 * MIT CSINAL
 * A Shopify "vegyel egyet, kapsz egyet" automatikus kedvezmenye csak akkor sul el,
 * ha a vevo maga rakja be a masodik darabot. Aki paratlan darabszammal megy a
 * kasszahoz, teljes arat fizet az utolso darabert. Ez a banner ezt fogja meg.
 *
 * MIERT IGY
 * A korabbi valtozatok a theme belso mukodesere tamaszkodtak: hogy milyen
 * esemenyt kuld, hogyan rendereli ujra a kosarat, mikor csereli a tetellistat.
 * Minden ilyen feltetelezes mellett volt egy utvonal, ami kicsuszott.
 *
 * Ez a valtozat egyetlen dolgot hasznal, a Shopify sajat /cart.js vegpontjat,
 * ami minden temaban, minden oldalon, minden korulmenyek kozott ugyanazt adja:
 * a kosar tenyleges tartalmat. Ebbol szamol, es ebbol rajzol. Nincs mit
 * szinkronban tartani, nincs mit talalgatni.
 *
 * A Liquid oldalon csak egy ures keret van, hogy a banner a helyere kerulhessen.
 * Ha a keret hianyzik, a szkript letrehozza.
 *
 * HIBAKERESES
 *   wellifePromo.debug = true    reszletes naplo a konzolba
 *   wellifePromo.check()         kezi ellenorzes
 *   wellifePromo.state()         aktualis allapot
 */
(function () {
  'use strict';

  if (window.wellifePromo) return;

  /* ================================================================ */
  /* CONFIG                                                            */
  /*                                                                   */
  /* KIKAPCSOLAS: az endsAt lejarta utan a banner magatol eltunik,      */
  /* nincs teendo. Ha korabban kell levenni, enabled: false.           */
  /*                                                                   */
  /* UJRA BEKAPCSOLAS: ird at a startsAt es endsAt erteket. Mas         */
  /* termekhez a variantId-t kell cserelni.                            */
  /*                                                                   */
  /* FONTOS: a ket datum egyezzen a Shopify adminban beallitott         */
  /* automatikus kedvezmeny futasidejevel. Ha a banner tovabb el, mint  */
  /* a kedvezmeny, olyat iger a vevonek, amit a checkout nem ad meg.    */
  /* ================================================================ */

  var CONFIG = {
    enabled: true,
    variantId: 55656763392326,
    buy: 1,
    get: 1,
    startsAt: '2026-08-13T00:00:00+02:00',
    endsAt: '2026-09-30T23:59:59+02:00',
    text: {
      eyebrow: '1+1 akci\u00f3',
      title: 'M\u00e9g egy doboz j\u00e1r aj\u00e1nd\u00e9kba',
      bodyOne: 'Most {qty} doboz van a kosaradban. M\u00e9g {missing} dobozt nem sz\u00e1molunk fel.',
      giftLabel: 'Aj\u00e1nd\u00e9k doboz',
      cta: 'Hozz\u00e1adom aj\u00e1nd\u00e9kba',
      done: 'Az aj\u00e1nd\u00e9k doboz benne van a kosaradban'
    }
  };

  /* ================================================================ */

  var ROOT_SEL = '[data-wellife-promo-root]';
  var SHIP_SEL = '[data-wellife-shipping-info]';
  var ITEMS_SEL = '[data-items-holder]';
  var DRAWER_SEL = '[data-cart-drawer]';
  var WATCH_SEL = ITEMS_SEL + ',' + DRAWER_SEL + ',[data-foot-holder],[data-cart-price-holder]';

  var shop = window.wellifePromoShop || {};
  var MONEY_FORMAT = shop.moneyFormat || '{{amount_no_decimals_with_space_separator}} Ft';
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_JS = routeRoot + 'cart.js';
  var CHANGE_URL = shop.cartChangeUrl || (routeRoot + 'cart/change');

  var lastHTML = null;
  var checking = false;
  var recheck = false;
  var applying = false;
  var timer = null;
  var lastCheck = 0;

  var api = {
    debug: false,
    check: function () { check(); },
    state: function () {
      return { roots: liveRoots().length, lastCheck: lastCheck, html: lastHTML };
    }
  };
  window.wellifePromo = api;

  function log() {
    if (!api.debug) return;
    try { console.log.apply(console, ['[wellife-promo]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  /* ---------------------------------------------------------------- */
  /* Penznem formazas, a bolt sajat formatuma szerint                  */
  /* ---------------------------------------------------------------- */

  var TOKEN = /\{\{\s*(\w+)\s*\}\}/;

  function withDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents === null) return '0';
    var number = (cents / 100).toFixed(precision);
    var parts = number.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function money(cents) {
    var match = MONEY_FORMAT.match(TOKEN);
    var token = match ? match[1] : 'amount';
    var value;

    switch (token) {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }

    return MONEY_FORMAT.replace(TOKEN, value);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ---------------------------------------------------------------- */
  /* Keret                                                             */
  /* ---------------------------------------------------------------- */

  function liveRoots() {
    // A querySelectorAll nem lat bele a <template> tartalmaba, ezert csak a
    // tenylegesen kirajzolt kereteket kapjuk vissza. Pontosan ezt akarjuk.
    return Array.prototype.slice.call(document.querySelectorAll(ROOT_SEL));
  }

  function createRoot() {
    var anchor = document.querySelector(SHIP_SEL) || document.querySelector(ITEMS_SEL);
    if (!anchor || !anchor.parentNode) return null;

    var el = document.createElement('div');
    el.setAttribute('data-wellife-promo-root', '');
    anchor.parentNode.insertBefore(el, anchor);
    log('keret letrehozva');
    return el;
  }

  /* ---------------------------------------------------------------- */
  /* Allapot es markup                                                 */
  /* ---------------------------------------------------------------- */

  function promoActive(now) {
    if (!CONFIG.enabled) return false;
    var start = new Date(CONFIG.startsAt).getTime();
    var end = new Date(CONFIG.endsAt).getTime();
    if (isNaN(start) || isNaN(end)) return false;
    return now >= start && now <= end;
  }

  function build(cart) {
    if (!promoActive(Date.now())) return '';

    var items = (cart && cart.items) || [];
    var qty = 0;
    var line = 0;
    var lineQty = 0;
    var unit = 0;

    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id !== CONFIG.variantId) continue;
      qty += items[i].quantity;
      if (line === 0) {
        line = i + 1; // a /cart/change a sor sorszamat varja, egytol indulva
        lineQty = items[i].quantity;
        unit = items[i].original_price;
      }
    }

    if (qty === 0) return '';

    var block = CONFIG.buy + CONFIG.get;
    var rest = qty % block;
    var missing = rest === 0 ? 0 : block - rest;

    if (missing === 0) {
      return (
        '<p class="wl-promo wl-promo--done" data-wellife-promo-banner="done">' +
          '<svg class="wl-promo__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
            'stroke-width="2" aria-hidden="true" focusable="false">' +
            '<path d="M20 6 9 17l-5-5"></path>' +
          '</svg>' +
          '<span>' + escapeHtml(CONFIG.text.done) + '</span>' +
        '</p>'
      );
    }

    var target = lineQty + missing;
    var href = CHANGE_URL + '?line=' + line + '&quantity=' + target;
    var body = CONFIG.text.bodyOne
      .replace('{qty}', qty)
      .replace('{missing}', missing);

    return (
      '<div class="wl-promo" data-wellife-promo-banner="nudge">' +
        '<p class="wl-promo__eyebrow">' + escapeHtml(CONFIG.text.eyebrow) + '</p>' +
        '<p class="wl-promo__title">' + escapeHtml(CONFIG.text.title) + '</p>' +
        '<p class="wl-promo__body">' + escapeHtml(body) + '</p>' +
        '<div class="wl-promo__ledger">' +
          '<span class="wl-promo__ledger-label">' + escapeHtml(CONFIG.text.giftLabel) + '</span>' +
          '<span class="wl-promo__ledger-value">' +
            '<s>' + escapeHtml(money(unit * missing)) + '</s>' +
            '<strong>' + escapeHtml(money(0)) + '</strong>' +
          '</span>' +
        '</div>' +
        '<a class="wl-promo__cta" href="' + escapeHtml(href) + '">' + escapeHtml(CONFIG.text.cta) + '</a>' +
      '</div>'
    );
  }

  function render(html) {
    var roots = liveRoots();

    if (!roots.length) {
      if (!html) return;
      var made = createRoot();
      if (!made) { log('nincs hova tenni a bannert'); return; }
      roots = [made];
    }

    applying = true;
    var changed = 0;
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].innerHTML.trim() !== html) {
        roots[i].innerHTML = html;
        changed++;
      }
    }
    setTimeout(function () { applying = false; }, 0);

    lastHTML = html;
    log('kirajzolva, valtozott', changed, 'keret', roots.length, 'tartalom', html ? 'van' : 'nincs');
  }

  /* ---------------------------------------------------------------- */
  /* Ellenorzes                                                        */
  /* ---------------------------------------------------------------- */

  function check() {
    if (checking) { recheck = true; return; }

    checking = true;
    lastCheck = Date.now();

    fetch(CART_JS + '?wlpromo=1', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        log('kosar', cart && cart.item_count, 'tetel');
        render(build(cart));
      })
      .catch(function (err) { log('hiba', err); })
      .then(function () {
        checking = false;
        if (recheck) { recheck = false; schedule(120); }
      });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(check, typeof delay === 'number' ? delay : 250);
  }

  // Egy felhasznaloi muvelet utan nem tudjuk, mikor fejezi be a theme a sajat
  // munkajat, ezert tobb idopontban is ranezunk.
  function burst() {
    schedule(300);
    setTimeout(check, 1100);
    setTimeout(check, 2200);
  }

  /* ---------------------------------------------------------------- */
  /* Jelek                                                             */
  /* ---------------------------------------------------------------- */

  function isCartRequest(url) {
    var u = String(url || '');
    if (u.indexOf('/cart') === -1) return false;
    if (u.indexOf('wlpromo=1') !== -1) return false;
    return true;
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var call = nativeFetch.apply(this, arguments);
      if (isCartRequest(url)) call.then(function () { schedule(200); }, function () {});
      return call;
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartRequest(url)) this.addEventListener('load', function () { schedule(200); });
    return nativeOpen.apply(this, arguments);
  };

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest(ROOT_SEL)) return;
    burst();
  }, true);

  document.addEventListener('submit', function () { burst(); }, true);

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:added', 'theme:cart:change']
    .forEach(function (name) { document.addEventListener(name, function () { schedule(200); }); });

  function inCart(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.closest && node.closest(ROOT_SEL)) return false;
    if (node.closest && node.closest(WATCH_SEL)) return true;
    if (node.matches && node.matches(WATCH_SEL)) return true;
    if (node.querySelector && node.querySelector(WATCH_SEL)) return true;
    return false;
  }

  function watch() {
    if (typeof MutationObserver !== 'function' || !document.body) return;

    new MutationObserver(function (records) {
      if (applying) return;
      for (var i = 0; i < records.length; i++) {
        if (inCart(records[i].target)) { schedule(); return; }
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          if (inCart(records[i].addedNodes[j])) { schedule(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) check();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') return;
    if (Date.now() - lastCheck > 15000) check();
  });

  /* ---------------------------------------------------------------- */

  function start() {
    watch();
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
